// Image Constants - All images used across components and views
import micIcon from "../assets/images/mic_icon.svg";
import sendMessIcon from "../assets/images/send_mess_icon.svg";
import mediaOpenIcon from "../assets/images/media_open_icon.svg";
import playerImage from "../assets/images/player_image.svg";
import mainLogo from "../assets/images/main_logo.svg";
import whiteBackArrow from "../assets/images/white_back_arrow.svg";
import cardInfoImage from "../assets/images/card_info_image.svg";
import playerProfileImage from "../assets/images/player_profile_image.svg";
import harmanpreetProfile from "../assets/images/harmanpreet_profile.svg";
import cameraIcon from "../assets/images/camera_icon.svg";
import galleryMatchImage from "../assets/images/gallery_match_image.svg";
import noGalleryImage from "../assets/images/no_gallery_image.svg";
import subheaderDropdown from "../assets/images/subheader_dropdown.svg";
import dropdownIcon from "../assets/images/dropdown_icon.svg";
import matchCardImage from "../assets/images/match_card_image.svg";
import leagueDropupIcon from "../assets/images/league_dropup_icon.svg";
import closeDropdownIcon from "../assets/images/close_dropdown_icon.svg";
import shareIcon from "../assets/images/share_icon.svg";
import mostValuablePlayer from "../assets/images/most_valuable_player.svg";
import cardLocationIcon from "../assets/images/card_location_icon.svg";
import darkSearchIcon from "../assets/images/dark_search_icon.svg";
import backArrow from "../assets/images/backArrow.svg";
import cardArrowImage from "../assets/images/card_arrow_image.svg";
import locationCardIcon from "../assets/images/location_card_icon.svg";
import addIcon from "../assets/images/add_icon.svg";
import filterIcon from "../assets/images/filter_icon.svg";
import cardShowIcon from "../assets/images/card_show_icon.svg";
import tableDateIcon from "../assets/images/table_date_icon.svg";
import tableStatusIcon from "../assets/images/table_status_icon.svg";
import listViewIcon from "../assets/images/list_view_icon.svg";
import analysisDropdown from "../assets/images/analysis_dropdown.svg";
import whiteMiniDropdownIcon from "../assets/images/white_mini_dropdown_icon.svg";
import blackDot from "../assets/images/black_dot.svg";
import whoteDropupIcon from "../assets/images/whote_dropup_icon.svg";
import breadcrumbIcon from "../assets/images/breadcrumb_icon.svg";
import searchIconInput from "../assets/images/search_icon_input.svg";
import previousIcon from "../assets/images/previous_icon.svg";
import membersActive from "../assets/images/members_active.svg";
import membersNotActive from "../assets/images/members_notActive.svg";
import matchesActive from "../assets/images/matches_active.svg";
import matchesNotActive from "../assets/images/matches_notActive.svg";
import statsActive from "../assets/images/stats_active.svg";
import statsNotActive from "../assets/images/stats_notActive.svg";
import photosNotActive from "../assets/images/photos_notActive.svg";
import teamLogo from "../assets/images/team_logo.svg";
import shareButton from "../assets/images/share-button.svg";
import liveActive from "../assets/images/live_active.svg";
import upcomingActive from "../assets/images/upcoming_active.svg";
import pastActive from "../assets/images/past_active.svg";
import liveNotActive from "../assets/images/live_not_active.svg";
import upcomingNotActive from "../assets/images/upcoming_not_active.svg";
import scheduleIcon from "../assets/images/schdule_icon.svg";
import pastNotActive from "../assets/images/past_not_active.svg";
import dropdownFilterIcon from "../assets/images/dropdown_filter_icon.svg";
import matchFilterShow from "../assets/images/match_filter_show.svg";
import matchFilterNotShow from "../assets/images/match_filter_notShow.svg";
import squadCardLogo from "../assets/images/squad_card_logo.svg";
import squadSearchIcon from "../assets/images/squad_search_icon.svg";
import teamMemberPlaceholder from "../assets/images/team_member_placeholder.svg";
import batIcon from "../assets/images/bat_icon.svg";
import ballIcon from "../assets/images/ball_icon.svg";
import handsIcon from "../assets/images/hands_icon.svg";
import cIcon from "../assets/images/c_icon.svg";
import vcIcon from "../assets/images/vc_icon.svg";
import searchIcon from "../assets/images/search_icon.svg";
import groundImage from "../assets/images/ground_image.svg";
import matchDetailsDot from "../assets/images/match_details_dot.svg";
import defaultTeamImage from "../assets/images/default_team_image.svg";
import playerOfTheMatchImage from "../assets/images/player_ofTheMatch_image.svg";
import scorecardIcon from "../assets/images/scorecard_icon.svg";
import blueLocation from "../assets/images/blue_location.svg";
import greenDotIcon from "../assets/images/green_dot_icon.svg";
import vsIcon from "../assets/images/vs_icon.svg";
import playerIcon from "../assets/images/player_icon.svg";
import umpireIcon1 from "../assets/images/umpire_icon_1.svg";
import umpireIcon2 from "../assets/images/umpire_icon_2.svg";
import tvUmpire from "../assets/images/tv_umpire.svg";
import reserveUmpire from "../assets/images/reserve_umpire.svg";
import calendarDropdownIcon from "../assets/images/calendar_dropdown_icon.svg";
import calendarRightIcon from "../assets/images/calendar_right_icon.svg";
import calendarLeftIcon from "../assets/images/calendar_left_icon.svg";
import dummyProfile from "../assets/images/dummy_profile.svg";
import locationIcon from "../assets/images/location_icon.svg";
import notificationIcon from "../assets/images/notification_icon.svg";
import miniDropdownIcon from "../assets/images/mini_dropdown_icon.svg";
import blueLocationIcon from "../assets/images/blue_location_icon.svg";
import playerMinProfile from "../assets/images/player_mini_profile.svg";
import playerOfTheMatchImage2 from "../assets/images/playerOfTheMatch_image.svg";
import createTournamentBgImage from "../assets/images/create_tournament_bg_image.svg";
import shareMatchSummaryIcon from "../assets/images/share_matchSummary_icon.svg";
import successIcon from "../assets/images/success_icon.svg";
import checkIcon from "../assets/images/check_icon.svg";
import copyIcon from "../assets/images/copy_icon.svg";
import countryFlag from "../assets/images/country_flag.svg";
import emglandPlusIcon from "../assets/images/emgland_plus_icon.svg";
import indiaFlagIcon from "../assets/images/india_flag_icon.svg";
import selectArrowIcon from "../assets/images/select_arrow_icon.svg";
import streamerIcon from "../assets/images/streamer_icon.svg";
import squadStreamerIcon from "../assets/images/squad_streamer_icon.svg";
import batsmanStreamerIcon from "../assets/images/batsman_streamer_icon.svg";
import batterStreamerIcon from "../assets/images/batter_streamer_icon.svg";
import boundaryTeamStreamerIcon from "../assets/images/boundaryTeam_streamer_icon.svg";
import bowlerStreamerIcon from "../assets/images/bowler_streamer_icon.svg";
import bowlerDetailsStreamerIcon from "../assets/images/bowlerDetails_streamer_icon.svg";
import commNewIcon from "../assets/images/comm_new_icon.svg";
import compareButtonImg from "../assets/images/compare_button_img.svg";
import foursStreamerIcon from "../assets/images/fours_streamer_icon.svg";
import inningChartStreamerIcon from "../assets/images/inningChart_streamer_icon.svg";
import matchExtraStreamerIcon from "../assets/images/matchExtra_streamer_icon.svg";
import matchSchduleStreamerIcon from "../assets/images/matchSchdule_streamer_icon.svg";
import mostRunBatIcon from "../assets/images/mostRun_bat_icon.svg";
import nextMatchStreamerIcon from "../assets/images/nextMatch_streamer_icon.svg";
import partnershipStreamerIcon from "../assets/images/partnership_streamer_icon.svg";
import playerStatsStreamerIcon from "../assets/images/playerStats_streamer_icon.svg";
import runRateStreamerIcon from "../assets/images/runRate_streamer_icon.svg";
import runsChartStreamerIcon from "../assets/images/runsChart_streamer_icon.svg";
import shotAnalysisStreamerIcon from "../assets/images/shotAnalysis_streamer_icon.svg";
import sixStreamerIcon from "../assets/images/six_streamer_icon.svg";
import teamExtraStreamerIcon from "../assets/images/teamExtra_streamer_icon.svg";
import tossWinStreamerIcon from "../assets/images/tossWin_streamer_icon.svg";
import wagonStreamerIcon from "../assets/images/wagon_streamer_icon.svg";
import winningStreamerIcon from "../assets/images/winning_streamer_icon.svg";
import wicketStreamerIcon from "../assets/images/wicket_streamer_icon.svg";
import asBatterIcon from "../assets/images/asBatter_icon.svg";
import asBowlIcon from "../assets/images/asBowl_icon.svg";
import ballingRecordIcon from "../assets/images/balling_record_icon.svg";
import battingRecordIcon from "../assets/images/batting_record_icon.svg";
import fieldingRecordIcon from "../assets/images/fielding_record_icon.svg";
import clearTickerIcon from "../assets/images/clear_ticker_icon.svg";
import analysisPlayerImage from "../assets/images/analysis_player_image.svg";
import analysisCrossIcon from "../assets/images/analysis_cross_icon.svg";
import analysisPlayerSearchIcon from "../assets/images/analysis_player_search_icon.svg";
import playerPlusIcon from "../assets/images/player_plus_icon.svg";
import matchSearchIcon from "../assets/images/match_search.svg";
import filterDropdownIcon from "../assets/images/filter_dropdown_icon.svg";
import filterDropupIcon from "../assets/images/filter_dropup_icon.svg";
import testActiveIcon from "../assets/images/Test_active.svg";
import odiNotActiveIcon from "../assets/images/ODI_notActive.svg";
import t20NotActiveIcon from "../assets/images/T20_notActive.svg";
import footerBackground from "../assets/images/footer_background.svg";
import facebookIcon from "../assets/images/facebook_icon.svg";
import instaIcon from "../assets/images/insta_icon.svg";
import twitterIcon from "../assets/images/twitter_icon.svg";
import linkedinIcon from "../assets/images/linkedin_icon.svg";
import sideArrowIcon from "../assets/images/side_arrow_icon.svg";
import new_chat_icon from "../assets/images/new_chat_icon.svg";
import copy_icon from "../assets/images/statgpt_copy_icon.svg";
import playerStatgptImage from "../assets/images/player_statgt_icon.svg";
import batman_bg_image from "../assets/images/batman_bg.svg";
import highest_score_icon from "../assets/images/statgpt_highest_run_icon.svg";
import most_wickets_icon from "../assets/images/statgpt_most_wicket_icon.svg";
import most_sixes_icon from "../assets/images/s_most_sixes.svg";
import top_all_rounder_icon from "../assets/images/s_top_All_Rounder.svg";
import pricing_tick from "../assets/images/pricing_tick.svg";
import myTeamBg from "../assets/images/my_team_bg.png";
import batBowlStBg from "../assets/images/bat_bowl_st_bg.png";
import bowlImage from "../assets/images/bowlImage.png";
import platformBg from "../assets/images/platformBg.png";
import blogImage from "../assets/images/blogImage.png";
import myLeaguesNo from "../assets/images/myLeaguesNo.png";
import noDocument from "../assets/images/noDocument.png";
// League card defaults: use public folder for reliable loading (bypasses import bundling)
const base =
  (typeof import.meta !== "undefined" && import.meta.env?.BASE_URL) || "/";
const participatedImage = `${base}images/participated.png`;
const createdImage = `${base}images/created.png`;
export const Images = {
  // Main Logo
  main_logo: mainLogo,

  // StatGPT
  mic_icon: micIcon,
  send_mess_icon: sendMessIcon,
  media_open_icon: mediaOpenIcon,
  player_image: playerImage,

  // Common
  no_data_image: myLeaguesNo,
  white_back_arrow: whiteBackArrow,
  card_info_image: cardInfoImage,
  back_arrow: backArrow,
  search_icon: searchIcon,
  search_icon_input: searchIconInput,
  dark_search_icon: darkSearchIcon,
  share_icon: shareIcon,
  share_button: shareButton,
  camera_icon: cameraIcon,
  breadcrumb_icon: breadcrumbIcon,
  black_dot: blackDot,
  cameraIcon: cameraIcon,

  // Player & Profile
  playerProfileImage: playerProfileImage,
  /** Same asset as `playerProfileImage` — snake_case alias used across match/squad views. */
  player_profile_image: playerProfileImage,
  harmanpreet_profile: harmanpreetProfile,
  player_icon: playerIcon,
  player_ofTheMatch_image: playerOfTheMatchImage,
  playerOfTheMatch_image: playerOfTheMatchImage2,
  player_mini_profile: playerMinProfile,
  dummy_profile: dummyProfile,

  // Gallery
  gallery_match_image: galleryMatchImage,
  no_gallery_image: noGalleryImage,

  // Header & Navigation
  subheader_dropdown: subheaderDropdown,
  dropdown_icon: dropdownIcon,
  mini_dropdown_icon: miniDropdownIcon,
  white_mini_dropdown_icon: whiteMiniDropdownIcon,
  league_dropup_icon: leagueDropupIcon,
  close_dropdown_icon: closeDropdownIcon,
  analysis_dropdown: analysisDropdown,
  whote_dropup_icon: whoteDropupIcon,
  dropdown_filter_icon: dropdownFilterIcon,

  // Match & Tournament
  match_card_image: matchCardImage,
  match_details_dot: matchDetailsDot,
  match_filter_show: matchFilterShow,
  match_filter_notShow: matchFilterNotShow,
  scorecard_icon: scorecardIcon,
  schedule_icon: scheduleIcon,
  share_matchSummary_icon: shareMatchSummaryIcon,

  // Location
  location_icon: locationIcon,
  card_location_icon: cardLocationIcon,
  location_card_icon: locationCardIcon,
  blue_location: blueLocation,
  blue_location_icon: blueLocationIcon,

  // Team
  team_logo: teamLogo,
  default_team_image: defaultTeamImage,
  team_member_placeholder: teamMemberPlaceholder,

  // Cards & UI
  card_arrow_image: cardArrowImage,
  card_show_icon: cardShowIcon,
  add_icon: addIcon,
  filter_icon: filterIcon,
  list_view_icon: listViewIcon,
  table_date_icon: tableDateIcon,
  table_status_icon: tableStatusIcon,
  pricing_tick: pricing_tick,

  // Team Info Tabs
  members_active: membersActive,
  members_notActive: membersNotActive,
  matches_active: matchesActive,
  matches_notActive: matchesNotActive,
  stats_active: statsActive,
  stats_notActive: statsNotActive,
  photos_notActive: photosNotActive,

  // Match Tabs
  live_active: liveActive,
  live_not_active: liveNotActive,
  upcoming_active: upcomingActive,
  upcoming_not_active: upcomingNotActive,
  past_active: pastActive,
  past_not_active: pastNotActive,

  // Squads
  squad_card_logo: squadCardLogo,
  squad_search_icon: squadSearchIcon,

  // Player Card
  bat_icon: batIcon,
  ball_icon: ballIcon,
  hands_icon: handsIcon,
  c_icon: cIcon,
  vc_icon: vcIcon,

  // Ground
  ground_image: groundImage,

  // Match Details
  green_dot_icon: greenDotIcon,
  vs_icon: vsIcon,

  // Umpires
  umpire_icon_1: umpireIcon1,
  umpire_icon_2: umpireIcon2,
  tv_umpire: tvUmpire,
  reserve_umpire: reserveUmpire,

  // Calendar
  calendar_dropdown_icon: calendarDropdownIcon,
  calendar_right_icon: calendarRightIcon,
  calendar_left_icon: calendarLeftIcon,

  // Top Header
  notification_icon: notificationIcon,
  previous_icon: previousIcon,

  // League Stats
  most_valuable_player: mostValuablePlayer,

  // Points Table
  success_icon: successIcon,
  check_icon: checkIcon,
  copy_icon: copyIcon,

  // Country & Flags
  country_flag: countryFlag,
  emgland_plus_icon: emglandPlusIcon,
  india_flag_icon: indiaFlagIcon,

  // Other Icons
  select_arrow_icon: selectArrowIcon,
  streamer_icon: streamerIcon,

  // Social Media Icons
  facebook_icon: facebookIcon,
  insta_icon: instaIcon,
  twitter_icon: twitterIcon,
  linkedin_icon: linkedinIcon,

  // Streamer Icons
  squad_streamer_icon: squadStreamerIcon,
  batsman_streamer_icon: batsmanStreamerIcon,
  batter_streamer_icon: batterStreamerIcon,
  boundaryTeam_streamer_icon: boundaryTeamStreamerIcon,
  bowler_streamer_icon: bowlerStreamerIcon,
  bowlerDetails_streamer_icon: bowlerDetailsStreamerIcon,
  comm_new_icon: commNewIcon,
  compare_button_img: compareButtonImg,
  fours_streamer_icon: foursStreamerIcon,
  inningChart_streamer_icon: inningChartStreamerIcon,
  matchExtra_streamer_icon: matchExtraStreamerIcon,
  matchSchdule_streamer_icon: matchSchduleStreamerIcon,
  mostRun_bat_icon: mostRunBatIcon,
  nextMatch_streamer_icon: nextMatchStreamerIcon,
  partnership_streamer_icon: partnershipStreamerIcon,
  playerStats_streamer_icon: playerStatsStreamerIcon,
  runRate_streamer_icon: runRateStreamerIcon,
  runsChart_streamer_icon: runsChartStreamerIcon,
  shotAnalysis_streamer_icon: shotAnalysisStreamerIcon,
  six_streamer_icon: sixStreamerIcon,
  teamExtra_streamer_icon: teamExtraStreamerIcon,
  tossWin_streamer_icon: tossWinStreamerIcon,
  wagon_streamer_icon: wagonStreamerIcon,
  winning_streamer_icon: winningStreamerIcon,
  wicket_streamer_icon: wicketStreamerIcon,

  // Player Stats
  asBatter_icon: asBatterIcon,
  asBowl_icon: asBowlIcon,
  balling_record_icon: ballingRecordIcon,
  batting_record_icon: battingRecordIcon,
  fielding_record_icon: fieldingRecordIcon,

  // Tournament
  create_tournament_bg_image: createTournamentBgImage,

  // Additional Icons
  clear_ticker_icon: clearTickerIcon,
  analysis_player_image: analysisPlayerImage,
  analysis_cross_icon: analysisCrossIcon,
  analysis_player_search_icon: analysisPlayerSearchIcon,
  player_plus_icon: playerPlusIcon,
  match_search: matchSearchIcon,
  filter_dropdown_icon: filterDropdownIcon,
  filter_dropup_icon: filterDropupIcon,
  Test_active: testActiveIcon,
  ODI_notActive: odiNotActiveIcon,
  T20_notActive: t20NotActiveIcon,

  //Footer
  footer_background: footerBackground,

  // My Team
  my_team_bg: myTeamBg,
  bat_bowl_st_bg: batBowlStBg,
  bowl_image: bowlImage,
  platform_bg: platformBg,
  blog_image: blogImage,
  my_leagues_no: myLeaguesNo,
  no_document: noDocument,
  participated_image: participatedImage,
  created_image: createdImage,

  //StatGpt
  new_chat_icon: new_chat_icon,
  side_arrow_icon: sideArrowIcon,
  statgpt_copy_icon: copy_icon,
  player_statgt_icon: playerStatgptImage,
  batman_bg_image: batman_bg_image,
  highest_score_icon: highest_score_icon,
  most_wickets_icon: most_wickets_icon,
  most_sixes_icon: most_sixes_icon,
  top_all_rounder_icon: top_all_rounder_icon,
};
